import React from "react";
import View from "../../Components/Tracking/View";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const ViewPage = ({ match, location }) => {
  const query = queryString.parse(location.search);

  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <View date={query.date} />
    </React.Fragment>
  );
};

export default ViewPage;
